import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { HomeIcon } from "../../../styles/img/svg/HomeIcon";
import { UserIcon } from "../../../styles/img/svg/UserIcon";
import { CardIcon } from "../../../styles/img/svg/CardIcon";
import { DepositIcon } from "../../../styles/img/svg/DepositIcon";
import { LoanIcon } from "../../../styles/img/svg/LoanIcon";
import { EmptyWalletIcon } from "../../../styles/img/svg/EmptyWalletIcon";
import { PortfolioNavIcon } from "../../../styles/img/svg/PortfolioNavIcon";
import { FavouriteIcon } from "../../../styles/img/svg/FavouriteIcon";
import { HistoryIcon } from "../../../styles/img/svg/HistoryIcon";
import { SettingsIcon } from "../../../styles/img/svg/SettingsIcon";
import { TrafficFinesMenuIcon } from "../../../styles/img/svg/TrafficFinesMenuIcon";
import {
  TRANSLATION_CONST,
  accountTypesConstants,
  commonContent,
} from "../../../_redux/_constants";
import { SomethingWrongModal } from "../../_uiComponents/Popups/SomethingWrongModal";
import { UiPopup } from "../../_uiComponents/common/UiModal";
import { ConfirmationIcon } from "../../../styles/img/svg/ConfirmationIcon";
import { ContactIcon } from "../../../styles/img/svg/ContactIcon";
import { LogoutSidebarIcon } from "../../../styles/img/svg/LogoutSidebarIcon";
import { logoutAuthRequest } from "../../../_redux/_actions/auth.actions";
import { LeaveConfirmationPopup } from "../Popups/ConfirmationPopup";
import { ServiceRequestNavIcon } from "../../../styles/img/svg/ServiceRequestNavIcon";
import { LeaseNavIcon } from "../../../styles/img/svg/LeaseNavIcon";
import { setActiveAccountTab } from "../../../_redux/_actions/account.actions";
import {
  clearCommonErrors,
  clearFineFormData,
  trafficSetSelectedPoliceStation,
  setServiceRequestFromExternal,
  clearServiceRequestFromExternal,
  serviceRequestTemplateFieldsRequest,
} from "../../../_redux/_actions";
import {
  serviceRequestCodes,
  serviceRequestConstants,
} from "../../../_redux/_constants";
import { PawningNavIcon } from "../../../styles/img/svg/PawningNavIcon";
import { SchedulePaymentsIcon } from "../../../styles/img/svg/SchedulePaymentsIcon";
import { RateIcon } from "../../../styles/img/svg/RateIcon";
import { openSafeExternalUrl } from "../../../_helpers/safeExternalUrl.helper";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

export const UiMenu = (props) => {
  const { handleToggle } = props;

  const dispatch = useDispatch();

  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const [isContactUsOpen, setIsContactUsOpen] = useState(false);
  const [linkToastOpen, setLinkToastOpen] = useState(false);
  const [routePath, setRoutePath] = useState(null);
  const [cashbackLoanPending, setCashbackLoanPending] = useState(false);
  const cashbackLoanRequestStartedRef = useRef(false);

  const externalServiceRequestData = useSelector(
    (state) => state?.serviceRequest?.externalServiceRequestData,
  );
  const serviceRequestTemplateFieldsList = useSelector(
    (state) => state?.serviceRequest?.serviceRequestTemplateFieldsList,
  );

  const pendingRequests = useSelector(
    (state) => state?.loading?.pendingRequests ?? [],
  );

  useState(() => {
    setRoutePath(location.pathname);
  }, []);

  const homeNavigate = () => {
    navigate("/app/dashboard");
    setRoutePath(location.pathname);
    if (typeof handleToggle === "function") {
      handleToggle();
    }
  };

  const accountsNavigate = () => {
    dispatch(setActiveAccountTab(accountTypesConstants.ALL_ACCOUNT_TYPE));
    navigate("/app/accounts");
    setRoutePath(location.pathname);
    if (typeof handleToggle === "function") {
      handleToggle();
    }
  };
  const cardsNavigate = () => {
    navigate("/app/cards");
    setRoutePath(location.pathname);
    if (typeof handleToggle === "function") {
      handleToggle();
    }
  };
  const fdNavigate = () => {
    navigate("/app/fixed-deposits");
    setRoutePath(location.pathname);
    if (typeof handleToggle === "function") {
      handleToggle();
    }
  };
  const loansNavigate = () => {
    navigate("/app/loans");
    setRoutePath(location.pathname);
    if (typeof handleToggle === "function") {
      handleToggle();
    }
  };

  const leaseNavigate = () => {
    navigate("/app/lease");
    setRoutePath(location.pathname);
    if (typeof handleToggle === "function") {
      handleToggle();
    }
  };

  const favouriteNavigate = () => {
    navigate("/app/favourites");
    setRoutePath(location.pathname);
    if (typeof handleToggle === "function") {
      handleToggle();
    }
  };
  const walletNav = () => {
    navigate("/app/wallet");
    setRoutePath(location.pathname);
    if (typeof handleToggle === "function") {
      handleToggle();
    }
  };
  const portfolioNav = () => {
    navigate("/app/portfolio");
    setRoutePath(location.pathname);
    if (typeof handleToggle === "function") {
      handleToggle();
    }
  };

  const settingsNav = () => {
    navigate("/app/settings");
    setRoutePath(location.pathname);
    if (typeof handleToggle === "function") {
      handleToggle();
    }
  };

  const historyNav = () => {
    navigate("/app/history");
    setRoutePath(location.pathname);
    if (typeof handleToggle === "function") {
      handleToggle();
    }
  };

  const schedulePaymentsNav = () => {
    navigate("/app/schedule-payments");
    setRoutePath(location.pathname);
    if (typeof handleToggle === "function") {
      handleToggle();
    }
  };

  const serviceRequestNav = () => {
    navigate("/app/more-services");
    setRoutePath(location.pathname);
    if (typeof handleToggle === "function") {
      handleToggle();
    }
  };

  const openExternalMenuLink = (url, linkKey) => {
    const opened = openSafeExternalUrl(url, "_blank");
    if (!opened) {
      console.warn(
        `[UiMenu] External menu link rejected or unavailable (${linkKey})`,
        { url: url || "(empty)" },
      );
      setLinkToastOpen(true);
      return;
    }

    if (typeof handleToggle === "function") {
      handleToggle();
    }
  };

  const rateAndChargesNav = () => {
    openExternalMenuLink(
      process.env.RATE_AND_CHARGES_LINK,
      "RATE_AND_CHARGES_LINK",
    );
  };

  const productInfoNav = () => {
    openExternalMenuLink(process.env.PRODUCT_INFO_LINK, "PRODUCT_INFO_LINK");
  };

  const faqNav = () => {
    openExternalMenuLink(process.env.FAQ_LINK, "FAQ_LINK");
  };

  const termsNav = () => {
    openExternalMenuLink(
      process.env.NFS_TERMS_CONDITION_LINK,
      "NFS_TERMS_CONDITION_LINK",
    );
  };

  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const handleCloseLogoutModal = () => {
    setShowLogoutModal(false);
  };

  const handleLogoutConfirm = () => {
    setShowLogoutModal(false);
    dispatch(logoutAuthRequest());
  };
  const logout = () => {
    if (typeof handleToggle === "function") {
      handleToggle();
    }
    setShowLogoutModal(true);
  };

  const trafficFineNavigate = () => {
    dispatch(clearCommonErrors());
    dispatch(trafficSetSelectedPoliceStation(null));
    dispatch(clearFineFormData());
    navigate("/app/traffic-fines");
    setRoutePath(location.pathname);
    if (typeof handleToggle === "function") {
      handleToggle();
    }
  };

  const pawningNavigate = () => {
    navigate("/app/pawning");
    setRoutePath(location.pathname);
    if (typeof handleToggle === "function") {
      handleToggle();
    }
  };

  const cashbackLoanNavigate = () => {
    cashbackLoanRequestStartedRef.current = false;
    dispatch(
      setServiceRequestFromExternal({
        serviceRequestTemplateCode:
          serviceRequestCodes.SERVICE_REQUEST_CASH_BACK_LOAN,
        returnPath: "/app/dashboard",
      }),
    );
    dispatch(
      serviceRequestTemplateFieldsRequest({
        locale: i18n.language,
        serviceRequestTemplateCode:
          serviceRequestCodes.SERVICE_REQUEST_CASH_BACK_LOAN,
      }),
    );
    setCashbackLoanPending(true);
    if (typeof handleToggle === "function") {
      handleToggle();
    }
  };

  // Only leave the dashboard for Cashback Loan after template fields succeed.
  // On failure (e.g. 12916), stay on dashboard and show the error alert.
  useEffect(() => {
    if (!cashbackLoanPending) return;

    const isTemplateFieldsPending = pendingRequests.includes(
      serviceRequestConstants.SERVICE_REQUEST_TEMPLATE_FIELDS_REQUEST,
    );

    if (isTemplateFieldsPending) {
      cashbackLoanRequestStartedRef.current = true;
      return;
    }

    // Wait until the request has actually started (avoids racing the first render)
    if (!cashbackLoanRequestStartedRef.current) return;

    const hasTemplateFields =
      Array.isArray(serviceRequestTemplateFieldsList) &&
      serviceRequestTemplateFieldsList.length > 0;

    setCashbackLoanPending(false);
    cashbackLoanRequestStartedRef.current = false;

    if (hasTemplateFields) {
      navigate("/app/more-services");
      setRoutePath("/app/more-services");
      return;
    }

    dispatch(clearServiceRequestFromExternal());
  }, [
    cashbackLoanPending,
    pendingRequests,
    serviceRequestTemplateFieldsList,
    dispatch,
    navigate,
  ]);

  return (
    <>
      <div className="df-sb-fixed-wrp">
        <div
          onClick={homeNavigate}
          className={
            routePath === "/app/dashboard"
              ? "df-sidebar__menu-item active"
              : "df-sidebar__menu-item"
          }
        >
          <HomeIcon />
          <h4>{t("Home")}</h4>
        </div>

        <div
          onClick={accountsNavigate}
          className={
            routePath === "/app/accounts"
              ? "df-sidebar__menu-item active"
              : "df-sidebar__menu-item"
          }
        >
          <UserIcon />
          <h4>{t("Savings")}</h4>
        </div>

        <div
          onClick={fdNavigate}
          className={
            routePath === "/app/fixed-deposits"
              ? "df-sidebar__menu-item active"
              : "df-sidebar__menu-item"
          }
        >
          <DepositIcon />
          <h4>{t("Fixed Deposits")}</h4>
        </div>

        <div
          onClick={loansNavigate}
          className={
            routePath === "/app/loans"
              ? "df-sidebar__menu-item active"
              : "df-sidebar__menu-item"
          }
        >
          <LoanIcon />
          <h4>{t("Lending")}</h4>
        </div>

        <div
          onClick={pawningNavigate}
          className={
            routePath === "/app/pawning"
              ? "df-sidebar__menu-item active"
              : "df-sidebar__menu-item"
          }
        >
          <PawningNavIcon />
          <h4>{t("Pawning")}</h4>
        </div>

        <div
          onClick={favouriteNavigate}
          className={
            routePath === "/app/favourites"
              ? "df-sidebar__menu-item active"
              : "df-sidebar__menu-item"
          }
        >
          <FavouriteIcon />
          <h4>{t("Favourites")}</h4>
        </div>

        <div
          onClick={historyNav}
          className={
            routePath === "/app/history"
              ? "df-sidebar__menu-item active"
              : "df-sidebar__menu-item"
          }
        >
          <HistoryIcon />
          <h4>{t("History")}</h4>
        </div>

        <div
          onClick={schedulePaymentsNav}
          className={
            routePath === "/app/schedule-payments"
              ? "df-sidebar__menu-item active"
              : "df-sidebar__menu-item"
          }
        >
          <SchedulePaymentsIcon />
          <h4>{t("Schedule Payments")}</h4>
        </div>

        <div
          onClick={serviceRequestNav}
          className={
            routePath === "/app/more-services"
              ? "df-sidebar__menu-item active"
              : "df-sidebar__menu-item"
          }
        >
          <ServiceRequestNavIcon />
          <h4>{t("Services")}</h4>
        </div>

        <div
          onClick={settingsNav}
          className={
            routePath === "/app/settings"
              ? "df-sidebar__menu-item active"
              : "df-sidebar__menu-item"
          }
        >
          <SettingsIcon />
          <h4>{t("Settings")}</h4>
        </div>

        <div
          onClick={rateAndChargesNav}
          className={"df-sidebar__menu-item"}
        >
          <RateIcon />
          <h4>{t("Rates & Charges")}</h4>
        </div>

        <div
          onClick={productInfoNav}
          className={"df-sidebar__menu-item"}
        >
         <ContactIcon />
         <h4>{t("Product Info")}</h4>
        </div>

        <div className={"df-sidebar__menu-item df-desk-hide"} onClick={logout}>
          <LogoutSidebarIcon />
          <h4>{t("Log Out")}</h4>
        </div>

        {/* Not in Lolc */}
        {/* 
        <div
          onClick={trafficFineNavigate}
          className={
            routePath === "/app/traffic-fines"
              ? "df-sidebar__menu-item active"
              : "df-sidebar__menu-item"
          }
        >
          <TrafficFinesMenuIcon />
          <h4>{t("Traffic Fines")}</h4>
        </div>

        <div
          onClick={cardsNavigate}
          className={
            routePath === "/app/cards"
              ? "df-sidebar__menu-item active"
              : "df-sidebar__menu-item"
          }
        >
          <CardIcon />
          <h4>{t("Cards")}</h4>
        </div>

        <div
          onClick={portfolioNav}
          className={
            routePath === "/app/portfolio"
              ? "df-sidebar__menu-item active"
              : "df-sidebar__menu-item"
          }
        >
          <PortfolioNavIcon />
          <h4>{t("My Portfolio")}</h4>
        </div>

        <div
          onClick={walletNav}
          className={
            routePath === "/app/wallet"
              ? "df-sidebar__menu-item active"
              : "df-sidebar__menu-item"
          }
        >
          <EmptyWalletIcon />
          <h4>{t("My Wallet")}</h4>
        </div>

        <div
          onClick={() => {
            setIsContactUsOpen(true);
            setRoutePath("/app/contact-us");
          }}
          className={
            routePath === "/app/contact-us"
              ? "df-sidebar__menu-item df-contact-active active"
              : "df-sidebar__menu-item df-contact"
          }
        >
          <ContactIcon />
          <h4>{t("Contact Us")}</h4>
        </div>

      </div>

      <div className="df-mobile-sidebar__footer ">
        <div className="df-mobile-faq">
          <div className={"df-sidebar__menu-item"}>
            <div
              className={
                i18n.language === TRANSLATION_CONST?.TAMIL.lan
                  ? "df-tc-menu df-tc-menu-tamil"
                  : "df-tc-menu"
              }
              onClick={faqNav}
            >
              {t("FAQ")}
            </div>

            <span className="df-mobile-faq__dot">.</span>

            <div
              className={
                i18n.language === TRANSLATION_CONST?.TAMIL.lan
                  ? "df-tc-menu df-tc-menu-tamil"
                  : "df-tc-menu"
              }
              onClick={termsNav}
            >
              {t("Terms and Conditions")}
            </div> */}
        {/* </div> */}
        {/* </div> */}
      </div>

      <UiPopup
        openModal={isContactUsOpen}
        handleClose={() => {
          setIsContactUsOpen(false);
          setRoutePath(location.pathname);
        }}
      >
        <SomethingWrongModal
          icon={<ConfirmationIcon />}
          message={t("LOLC Customer Support")}
          buttonText={t("Ok")}
          buttonOnClick={() => {
            setIsContactUsOpen(false);
            setRoutePath(location.pathname);
          }}
          className="df-confirmation-message-popup "
          buttonClass="df-ui-dark-bg-btn df-w-90-btn"
        >
          <p>{t("For assistance, call Customer Support at")} </p>

          <a
            className="df-primary-underlined-btn  mt-1 mb-0 df-link-color"
            href={`tel:${process.env.SUPPORT_CENTER_CONTACT_NUMBER}`}
          >
            {process.env.SUPPORT_CENTER_CONTACT_NUMBER_LABEL}
          </a>
        </SomethingWrongModal>
      </UiPopup>

      <UiPopup openModal={showLogoutModal} handleClose={handleCloseLogoutModal}>
        <LeaveConfirmationPopup
          icon={<ConfirmationIcon />}
          message=""
          successBtnText={t("Yes")}
          buttonOnClickClose={handleCloseLogoutModal}
          buttonOnClick={handleLogoutConfirm}
          className="df-confirmation-message-popup df-btn-grpdmodal"
        >
          <p>{t("Are you sure you want to log out?")}</p>
        </LeaveConfirmationPopup>
      </UiPopup>

      <Snackbar
        open={linkToastOpen}
        autoHideDuration={5000}
        onClose={() => setLinkToastOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setLinkToastOpen(false)}
          severity="warning"
          variant="filled"
          sx={{ width: "100%" }}
        >
          {t(
            "This link is not available right now. Please try again later.",
          )}
        </Alert>
      </Snackbar>
    </>
  );
};
